export default {
  videoCourses: {},
  coreConceptVideoCourses: [],
  unitsWithCoreConcepts: [],
};



// WEBPACK FOOTER //
// ./src/app/video-courses/store/state.js